/**
 * Finance options UI: tabs on desktop, carousel on mobile.
 * Also refreshes Humm/Klarna widgets when the product variant changes.
 */
(function () {
  var DESKTOP_MIN = 769;

  function refreshHumm(module, variantPrice) {
    var oldScript = module.querySelector('[data-finance-humm-script]');
    if (!oldScript) return;

    var url;
    try {
      url = new URL(oldScript.src, window.location.origin);
    } catch (err) {
      return;
    }
    url.searchParams.set('productPrice', (variantPrice / 100).toString());

    var container = oldScript.closest('[data-finance-humm-widget]') || oldScript.parentElement;
    var newScript = document.createElement('script');
    newScript.id = oldScript.id;
    newScript.setAttribute('data-finance-humm-script', '');
    newScript.src = url.toString();

    container.innerHTML = '';
    container.appendChild(newScript);
  }

  function refreshKlarna(module, variantPrice) {
    var placement = module.querySelector('klarna-placement');
    if (!placement) return;

    placement.setAttribute('data-purchase-amount', variantPrice);

    if (window.KlarnaOnsiteService) {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    } else if (window.Klarna && window.Klarna.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh();
    }
  }

  function refreshKlarnaPlacements(root) {
    if (window.KlarnaOnsiteService) {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    } else if (window.Klarna && window.Klarna.OnsiteMessaging) {
      window.Klarna.OnsiteMessaging.refresh();
    }
  }

  if (!customElements.get('finance-options')) {
    class FinanceOptions extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[data-finance-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-finance-panel]'));
        this.track = this.querySelector('[data-finance-track]');
        this.prevBtn = this.querySelector('[name="prev"]');
        this.nextBtn = this.querySelector('[name="next"]');
        this.statusCurrent = this.querySelector('[data-finance-status-current]');
        this.activeIndex = 0;
        this.isDesktop = window.innerWidth >= DESKTOP_MIN;
        this.onResize = this.handleResize.bind(this);
      }

      connectedCallback() {
        if (this.panels.length <= 1) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
        });

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.step(-1));
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.step(1));
        }

        window.addEventListener('resize', this.onResize);
        this.applyLayout();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      handleResize() {
        var wasDesktop = this.isDesktop;
        this.isDesktop = window.innerWidth >= DESKTOP_MIN;
        if (wasDesktop !== this.isDesktop) {
          this.applyLayout();
        }
      }

      applyLayout() {
        if (this.isDesktop) {
          if (this.track) this.track.style.transform = '';
          this.activate(this.activeIndex);
        } else {
          this.panels.forEach((panel) => {
            panel.hidden = false;
          });
          this.updateCarousel(false);
        }
      }

      step(direction) {
        var nextIndex = this.activeIndex + direction;
        if (nextIndex < 0) nextIndex = this.panels.length - 1;
        if (nextIndex >= this.panels.length) nextIndex = 0;
        this.activate(nextIndex);
      }

      activate(index) {
        if (!this.panels.length) return;

        this.activeIndex = index;

        if (this.isDesktop) {
          this.tabs.forEach((tab, tabIndex) => {
            var selected = tabIndex === index;
            tab.setAttribute('aria-selected', selected ? 'true' : 'false');
            tab.tabIndex = selected ? 0 : -1;
          });

          this.panels.forEach((panel, panelIndex) => {
            panel.hidden = panelIndex !== index;
          });

          if (this.track) this.track.style.transform = '';
        } else {
          this.updateCarousel(true);
        }

        if (this.statusCurrent) {
          this.statusCurrent.textContent = String(index + 1);
        }

        refreshKlarnaPlacements(this);
      }

      updateCarousel(animate) {
        if (!this.track) return;

        if (!animate) {
          this.track.style.transition = 'none';
        }

        this.track.style.transform = 'translateX(-' + (this.activeIndex * 100) + '%)';

        if (!animate) {
          this.track.offsetHeight;
          this.track.style.transition = '';
        }
      }
    }

    customElements.define('finance-options', FinanceOptions);
  }

  document.addEventListener('on:variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant || typeof variant.price !== 'number') return;

    document.querySelectorAll('[data-finance-module]').forEach(function (module) {
      refreshHumm(module, variant.price);
      refreshKlarna(module, variant.price);
    });
  });
})();
